import { enqueueSnackbar } from '../notificationActions';
import { SnackbarMessageVariants } from '../../../helpers/enums';
import {
    DataChartsNationalHaul
} from '../../../interfaces/truckLoadRateServiceInterfaces';
import ApiService from '../../../services/apiService';
import Endpoints from '../../../services/endpoints';

export const NATIONAL_HAUL_RATES_REQUEST = 'NATIONAL_HAUL_RATES_REQUEST';
export const NATIONAL_HAUL_RATES_SUCCESS = 'NATIONAL_HAUL_RATES_SUCCESS';
export const NATIONAL_HAUL_RATES_FAILURE = 'NATIONAL_HAUL_RATES_FAILURE';

const requestNationalHaulRates = (): object => {
    return {
        type: NATIONAL_HAUL_RATES_REQUEST
    };
};

const receiveNationalHaulRates = (json: object): object => {
    return {
        type: NATIONAL_HAUL_RATES_SUCCESS,
        payload: json
    };
};

const requestNationalHaulRatesFailed = (): object => {
    return {
        type: NATIONAL_HAUL_RATES_FAILURE
    };
};

export const fetchNationalHaulRates = (searchQuery: any): Function => {
    return async (dispatch: any): Promise<void> => {
        dispatch(requestNationalHaulRates());

        try {
            const json: DataChartsNationalHaul = await ApiService.post(Endpoints.chartsNationalHaul, searchQuery, true);

            if (Object.keys(json).length > 0) {
                dispatch(receiveNationalHaulRates(json));
            } else {
                dispatch(receiveNationalHaulRates({}));
            }
        } catch (err) {
            dispatch(requestNationalHaulRatesFailed());
            dispatch(enqueueSnackbar({
                message: 'Error occurred while fetching national haul rates.',
                variant: SnackbarMessageVariants.Error
            }));
        }
    };
};
